import { useContext } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { RumComponentContext } from './rumComponentContext.js';

/**
 * A hook that allows tracking of errors in Real User Monitoring (RUM).
 * It automatically adds the component chain/breadcrumbs from <RumComponentContextProvider>.
 *
 * @function
 *
 * @returns - A function that tracks a RUM error. Calls made before RUM is initialized are buffered by the SDK.
 */
export const useRumError = () => {
  const componentContext = useContext(RumComponentContext);

  return (
    error: unknown,
    customAttributes?: object,
    /** @deprecated Ignored: the SDK always reports custom errors with source "custom". */
    _source?: 'custom' | 'network' | 'source',
  ) => {
    datadogRum.addError(error, {
      ...componentContext.customAttributes,
      ...customAttributes,
      react: {
        breadcrumbs: componentContext.componentBreadCrumbs,
        ...(customAttributes as any)?.react,
      },
    });
  };
};
